import { combineReducers } from "@reduxjs/toolkit";

import { snackbarSlice } from "@mnemonic/feature-snackbar";

import baseApi from "./Service/baseApi";
import { globalSlice } from "./globalSlice";

const reducer = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  [globalSlice.name]: globalSlice.reducer,
  [snackbarSlice.reducerPath]: snackbarSlice.reducer,
});

export default reducer;
